import { formatPhoneNumber } from 'Shared/utils/formatters/phoneNumber';

/**
 * Returns a plain-text representation of a blocked attribute value.
 * Used for display in contexts where ReactNode is not appropriate.
 */
export const formatAttributeValueText = (
  attributeType: string,
  value: string | null | undefined
): string => {
  if (!value) return '';

  switch (attributeType) {
    case 'email':
    case 'email_domain':
      return value;

    case 'phone_number':
      return formatPhoneNumber(value);

    case 'vin':
      return value;

    case 'drivers_license': {
      // Canonical format: "CA:B92-2210-4498" → "CA · B92-2210-4498"
      const colonIdx = value.indexOf(':');
      if (colonIdx === -1) return value;
      const state = value.slice(0, colonIdx);
      const number = value.slice(colonIdx + 1);
      return `${state} · ${number}`;
    }

    case 'name_dob': {
      // Canonical format: "jane|smith|1985-03-22" → "Jane Smith · 1985-03-22"
      const parts = value.split('|');
      if (parts.length < 3) return value;
      const [firstName, lastName, dob] = parts;
      const cap = (s: string) =>
        s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
      return `${cap(firstName)} ${cap(lastName)} · ${dob}`;
    }

    default:
      return value;
  }
};
